import React from "react";
import parse from "html-react-parser";
import HeaderImage from "./HeaderImage";
import parseWithIcons from "../../utils/parseWithIcons";

const HeaderContent = ({ acf, post, src }) => {
  return (
    <header>
      <HeaderImage src={src} />
      <div className="inner">
        {post.pageCategories?.nodes[0]?.name && (
          <span className="category">
            {post.pageCategories?.nodes[0]?.name}
          </span>
        )}
        <h1>{parse(post.title)}</h1>
        {!!acf.contenthead && (
          <div className="content-head">{parseWithIcons(acf.contenthead)}</div>
        )}
      </div>
    </header>
  );
};

export default HeaderContent;
